const bafmGetter = (state) => state.bafm;

export const bafmSelector = (state) => ({
  bafm: bafmGetter(state)
});
